﻿const validatorPath = 'api/validator/';
const emailVerificationCodePath = 'api/verificationcode/email/';
const smsVerificationCodePath = 'api/verificationcode/sms/';
const authPath = `api/auth/`;
export const WebApiUrls = {
    validator: {
        validateUsername: `${validatorPath}validateusername`
    },
    sms: {
        sendlogincode: `${smsVerificationCodePath}sendlogincode`,
        sendforgotcode: `${smsVerificationCodePath}sendforgotpasswordcode`,
        sendbindmobilecode: `${smsVerificationCodePath}sendbindmobilecode`
    },
    email: {
        sendlogincode: `${emailVerificationCodePath}sendlogincode`,
        sendforgotcode: `${emailVerificationCodePath}sendforgotpasswordcode`,
        sendbindemailcode: `${emailVerificationCodePath}sendbindemailcode`
    },
    auth: {
        sendMfa: `${authPath}sendmfa`
    }
};